class BrowserStorage {
    storage;
    requestFrom;
    constructor(storage, requestFrom){
        this.storage = storage;
        this.requestFrom = requestFrom;
    }
    getItem(key) {
        return this.storage.getItem(key);
    }
    setItem(key, value) {
        this.storage.setItem(key, value);
    }
    removeItem(key) {
        this.storage.removeItem(key);
        this.storage.removeItem(`PennyInitialMessageSubmitted-${this.requestFrom}`);
    }
    updateUserMessageCount(count) {
        this.storage.setItem('PennyUserMessageCount', count);
    }
    getUserMessageCount() {
        const data = this.storage.getItem('PennyUserMessageCount');
        return parseInt(data, 10);
    }
    isInitialMessageSubmitted() {
        if (!this.storage) return true;
        return 'true' === this.storage.getItem(`PennyInitialMessageSubmitted-${this.requestFrom}`);
    }
    setInitialMessageSubmitted() {
        if (this.storage) this.storage.setItem(`PennyInitialMessageSubmitted-${this.requestFrom}`, 'true');
    }
}
const initBrowserStorageManager = ()=>{
    let browserStorage;
    return {
        initBrowserStorage: (requestFrom)=>{
            if ('undefined' == typeof window || !!browserStorage) return;
            browserStorage = new BrowserStorage(window.sessionStorage, requestFrom);
            return browserStorage;
        },
        getBrowserStorage: ()=>browserStorage
    };
};
const browserStorageManager = initBrowserStorageManager();
export { browserStorageManager, initBrowserStorageManager };
